import Vue from 'vue'
import App from './App.vue'
import router from './router'
import rem from './js/rem'
import axios from 'axios'
import Distpicker from 'v-distpicker'

rem();


Vue.component('v-distpicker', Distpicker)
Vue.config.productionTip = false
Vue.prototype.$http = axios
axios.defaults.baseURL = 'http://m.xiaoxxx.com'; 

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
